// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KUjIiaFnxUYfqhbc1NCX{white-space:pre-wrap;cursor:text;word-break:break-word;outline:none;height:116px;margin-right:4px;padding:12px 8px 4px 12px;font-size:14px;line-height:142.8%;overflow:auto}.KUjIiaFnxUYfqhbc1NCX.vqrmKqLuR02b4NtHx54Y{height:unset;min-height:76px;max-height:120px}.KUjIiaFnxUYfqhbc1NCX[placeholder]:empty:after{color:var(--content-neutral-primary);content:attr(placeholder);cursor:text}.KUjIiaFnxUYfqhbc1NCX.YwX9qE_LYIMOBFNro7BF:before{content:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KUjIiaFnxUYfqhbc1NCX`,
	"typeview": `vqrmKqLuR02b4NtHx54Y`,
	"withContent": `YwX9qE_LYIMOBFNro7BF`
};
export default ___CSS_LOADER_EXPORT___;
